// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"FirstLoginPage_contentContainer__2s7WF","formContainer":"FirstLoginPage_formContainer__2EFwk","language":"FirstLoginPage_language__2PI_h"};